import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const SidebarCloseSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      {...otherSvgProps}
    >
      <path d="M7 6L7 22L22 22L22 6L7 6Z" fill={fill} />
      <g filter="url(#filter0_d_1134_19731)">
        <path
          d="M4 9.81L4 18.19C4 21.83 6.17 24 9.81 24L18.18 24C21.83 24 24 21.83 24 18.19L24 9.82C24 6.18 21.83 4.01 18.19 4.01L9.81 4.01C6.17 4 4 6.17 4 9.81ZM12.98 17.53C12.69 17.24 12.69 16.76 12.98 16.47L14.7 14.75L8.51 14.75C8.1 14.75 7.76 14.41 7.76 14C7.76 13.59 8.1 13.25 8.51 13.25L14.7 13.25L12.98 11.53C12.69 11.24 12.69 10.76 12.98 10.47C13.27 10.18 13.75 10.18 14.04 10.47L17.04 13.47C17.11 13.54 17.16 13.62 17.2 13.71C17.24 13.8 17.26 13.9 17.26 14C17.26 14.1 17.24 14.19 17.2 14.29C17.16 14.38 17.11 14.46 17.04 14.53L14.04 17.53C13.75 17.82 13.28 17.82 12.98 17.53ZM19.22 7.76C19.89 9.77 20.23 11.88 20.23 14C20.23 16.12 19.89 18.23 19.22 20.24C19.09 20.63 18.66 20.84 18.27 20.71C17.88 20.58 17.66 20.16 17.8 19.76C19.04 16.04 19.04 11.95 17.8 8.23C17.67 7.84 17.88 7.41 18.27 7.28C18.67 7.16 19.09 7.37 19.22 7.76Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1134_19731"
          x="0"
          y="0.00976562"
          width="28"
          height="27.9902"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1134_19731" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1134_19731"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </span>
);

export default SidebarCloseSVG;
